// extracted by mini-css-extract-plugin
export var example = "style-module--example--09b2c";
export var example__figure = "style-module--example__figure--39b71";
export var example__image = "style-module--example__image--db349";
export var example__inner = "style-module--example__inner--c6bb6";
export var example__main = "style-module--example__main--7b40d";
export var example__title = "style-module--example__title--b7403";
export var examples = "style-module--examples--d5912";
export var examples__list = "style-module--examples__list--ea522";